'use strict';

function inherits(ctor, superCtor) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
}

module.exports = inherits;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/functions/inherits.js
// module id = 25
// module chunks = 0